import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { SsidChart } from "@mui/icons-material";
import meetJeremiah  from "../images/about_deb_bg.jpg";

const BuildingForOurFuture = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetJeremiah })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <SsidChart sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Building for Our Future
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Jeremiah will continue to support efforts to promote affordability and housing diversification throughout the County, prevent concentrations of poverty in certain school districts, and improve transportation access. Jeremiah has advocated for making it more affordable to purchase a home so more people can build generational wealth.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Overhauled the County’s 10-year growth plan, HoCo By Design, to promote affordable homes for purchase and ensure predictable growth strategies." />
              <Bullet text="Approved the redevelopment of the five aging low-income housing projects into modern, mixed-income apartments." />
              <Bullet text="Advocated for the expansion of the FLASH Bus Rapid Transit (BRT) along US 29." />
              <Bullet text="Encouraged the implementation of the Clarksville streetscape plan, including enhancements for pedestrian and bicycle usage." />
              <Bullet text="Voted for multiple rounds of gap funding for low-income housing projects, loans for first-time homebuyers, and improved requirements to build affordable units within new developments." />
              <Bullet text="Advocated for the consideration of school assignments when developing future affordable housing projects so that poverty isn’t concentrated in a few vulnerable census tracts." />
              <Bullet text="Co-sponsored legislation to prevent evictions and supported appropriation of funds to reduce housing insecurity and provide rent and utility assistance during the Covid lockdown." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default BuildingForOurFuture;
